import React from 'react'; 
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Axios from '../../../axios/axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';  // <-- Added for navigation
import './style.css'


// import "../style.css";

const Catalogue = () => {
  const [brands, setBrands] = useState([]);
  const navigate = useNavigate(); // <-- Initialize navigate

  const settings = {
    rows: 2,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    autoplay: true,                // 🔁 Enable autoplay
    autoplaySpeed: 2000,           // ⏱️  Time in milliseconds between scrolls (2 seconds)
    pauseOnHover: true,            // 🖱️ Pause autoplay when mouse hovers over
    nextArrow: (
      <div className="slick-arrow slick-next">
        <button className="btn btn-primary">
          <span className="fa fa-chevron-right"></span>
        </button>
      </div>
    ),
    prevArrow: (
      <div className="slick-arrow slick-prev">
        <button className="btn btn-primary">
          <span className="fa fa-chevron-left"></span>
        </button>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 680,
        settings: {
          rows: 1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          rows: 1,
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await Axios.get('/type/building');
        setBrands(response.data);
      } catch (error) {
        console.error('Error fetching brands:', error);
      }
    };
    fetchBrands();
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center catelogue-container"
      style={{ marginTop: '-2%' }}
    >
      <div className="shadow-sm p-3 mb-5 bg-white rounded Catalogue-container">
        {/* Search by Catalogue */}
        <section>
          <h2 className="text-center mt-5 Layout-Title">SEARCH BY BRAND</h2>
          <Slider {...settings}>
            {brands.map((brand) => (
              <div className="slide-item" key={brand._id}>
                {/* Changed <a> to div and added onClick */}
                <div
                  className="slider-div text-center"
                  style={{ cursor: 'pointer' }}
                  onClick={() =>
                    navigate(`/others/category?brandId=${brand._id}`)
                  }
                >
                  <img
                    src={brand.images[0] || '/images/default.png'}
                    className="img-fluid w-50"
                    alt={brand.name}
                    style={{ objectFit: 'contain', height: '101px', width: '179px' }}
                  />
                  <p>{brand.name}</p>
                </div>
              </div>
            ))}
          </Slider>
        </section>
      </div>
    </div>
  );
};

export default Catalogue;
